import { useState } from "react";
import { AssetDetailsDTO, AssetKey } from "../../dto/AssetDTO";
import { ReactComponent as FileIcon } from "./assets/file.svg";

/**
 * Row-sized preview for the list view: the thumbnail when there is one,
 * otherwise the type-tinted file glyph the cards already use.
 */
export default function AssetRowIcon(props: { asset: AssetDetailsDTO }) {
  const { asset } = props;
  const [failed, setFailed] = useState(false);
  const thumbnail = asset.variants[0]?.downloadUri;

  if (asset.key === AssetKey.Image && thumbnail && !failed) {
    return (
      <img
        src={thumbnail}
        alt=""
        loading="lazy"
        className="w-full h-full object-cover rounded-[5px]"
        onError={() => setFailed(true)}
      />
    );
  }

  const tintClass =
    asset.key === AssetKey.Pdf
      ? "assetcard-pdf"
      : asset.key === AssetKey.Video
        ? "assetcard-video"
        : asset.key === AssetKey.Audio
          ? "assetcard-audio"
          : asset.key === AssetKey.Unsupported
            ? "assetcard-unsupported-icon"
            : "assetcard-loading-icon";

  return <FileIcon className={tintClass + " w-[18px] h-[18px]"} />;
}
